/** Puane merkezi Nebim Lot / gerçek beden dağılımı motoru. */
(() => {
  'use strict';

  const normalize = (value) => String(value || '')
    .trim()
    .toLocaleUpperCase('tr-TR')
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, '');

  let rules = [];
  const data = document.getElementById('PuaneLotRulesData');

  try {
    rules = JSON.parse(data?.textContent || '[]');
  } catch (error) {
    console.error('[Puane Lot] Merkezi Lot kuralları okunamadı.', error);
  }

  const byRaw = new Map();
  const byDisplay = new Map();

  rules.forEach((rule) => {
    const normalizedRule = {
      raw: String(rule.raw || '').trim(),
      display: String(rule.display || '').trim(),
      quantity: Math.max(1, Number.parseInt(rule.quantity, 10) || 1),
      known: true,
    };

    byRaw.set(normalize(normalizedRule.raw), normalizedRule);
    if (!byDisplay.has(normalize(normalizedRule.display))) {
      byDisplay.set(normalize(normalizedRule.display), normalizedRule);
    }
  });

  const fallback = (value) => {
    const raw = normalize(value);
    if (!raw) return null;

    const numericRange = raw.match(/^(\d+)-(\d+)$/);
    if (numericRange) {
      const first = Number(numericRange[1]);
      const last = Number(numericRange[2]);
      if (last > first && last - first <= 30) {
        return {
          raw: String(value || '').trim(),
          display: String(value || '').trim(),
          quantity: Math.floor((last - first) / 2) + 1,
          known: false,
        };
      }
    }

    const parts = raw.split('-').filter(Boolean);
    if (parts.length > 0) {
      return {
        raw: String(value || '').trim(),
        display: String(value || '').trim(),
        quantity: parts.length,
        known: false,
      };
    }

    return null;
  };

  const directResolve = (value) => byRaw.get(normalize(value)) || byDisplay.get(normalize(value)) || null;

  const extract = (text) => {
    const original = String(text || '').trim();
    if (!original) return '';

    const direct = directResolve(original);
    if (direct) return direct.raw;

    const slashCandidate = original.split('/').pop().trim();
    const slashRule = directResolve(slashCandidate);
    if (slashRule) return slashRule.raw;

    const labelCandidate = original.split(/(?:lot|seri|beden(?:\s+grubu)?)\s*:\s*/i).pop().trim();
    const labelRule = directResolve(labelCandidate);
    if (labelRule) return labelRule.raw;

    const normalizedText = normalize(original);
    const match = [...byRaw.entries()]
      .sort((a, b) => b[0].length - a[0].length)
      .find(([key]) => normalizedText.includes(key));

    return match ? match[1].raw : '';
  };

  const resolve = (value) => {
    const direct = directResolve(value);
    if (direct) return { ...direct };

    const extracted = extract(value);
    if (extracted) return { ...byRaw.get(normalize(extracted)) };

    return fallback(value);
  };

  const count = (value) => resolve(value)?.quantity ?? null;
  const display = (value) => resolve(value)?.display || String(value || '').trim();

  window.PuaneLotRules = Object.freeze({
    rules: Object.freeze(rules.map((rule) => Object.freeze({ ...rule }))),
    normalize,
    extract,
    resolve,
    count,
    display,
  });
})();
